import { CommonModule, registerLocaleData } from '@angular/common';
import { Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FuseConfigService } from '@fuse/services/config';

import { AlertService } from '@utils/alert-service/alert-service.service';
import { Observable } from 'rxjs';

import localeEs from '@angular/common/locales/es';
import localeEsHN from '@angular/common/locales/es-HN';

registerLocaleData(localeEs);
registerLocaleData(localeEsHN);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, CommonModule, FuseAlertComponent],
    providers: [
        { provide: LOCALE_ID, useValue: 'es-HN' }
    ]
})
export class AppComponent implements OnInit {
    private fuseConfigService = inject(FuseConfigService);
    private alertService = inject(AlertService);

    ngOnInit(): void {
        this.fuseConfigService.config = '';
    }

    errorMessage$: Observable<{
        message: string;
        title?: string;
        errors: Array<string> | null;
    }> = this.alertService.message$;
    updateMessage$: Observable<string> = this.alertService.updateMessage$;
    saveMessage$: Observable<string> = this.alertService.saveMessage$;
}
